<template>
    <div class="ds-ex-period" v-click-outside="close" @keydown.esc.stop="close">
        <button v-if="monthMode" type="button" class="ds-ex-icon-btn" aria-label="Предыдущий месяц" @click="shiftMonth(-1)">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M15 6l-6 6 6 6" /></svg>
        </button>
        <button
            type="button"
            class="ds-ex-filter is-selected ds-ex-period-trigger"
            :class="{ 'is-month': monthMode }"
            aria-haspopup="dialog"
            :aria-expanded="isOpen"
            :aria-label="`Период: ${label}`"
            @click="isOpen = !isOpen"
        >
            <span>{{ label }}</span>
            <svg v-if="!monthMode" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true"><rect x="2.5" y="3.5" width="11" height="10" rx="2" stroke="currentColor" stroke-width="1.3" /><path d="M2.5 6.5h11M5.5 2v3M10.5 2v3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" /></svg>
        </button>
        <button v-if="monthMode" type="button" class="ds-ex-icon-btn" aria-label="Следующий месяц" @click="shiftMonth(1)">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M9 6l6 6-6 6" /></svg>
        </button>
        <div v-if="isOpen" class="ds-calendar-popover ds-calendar-popover-wide ds-ex-period-popover">
            <AppCalendar
                :model-value="draft"
                :initial-date="draft?.[0] ?? undefined"
                mode="range"
                presets
                @update:model-value="onSelect"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import dayjs, { type Dayjs } from 'dayjs'
import AppCalendar from '@/ui/AppCalendar.vue'
import { isFullMonth, monthLabel, periodLabel } from './exchangeFormat'

const period = defineModel<[string, string]>({ required: true })

const isOpen = ref(false)
const draft = ref<[Dayjs, Dayjs] | null>(null)

watch(period, value => { draft.value = [dayjs(value[0]), dayjs(value[1])] }, { immediate: true })

const monthMode = computed(() => isFullMonth(period.value))
const label = computed(() => monthMode.value ? monthLabel(period.value[0]) : periodLabel(period.value))

// Как RD-160: второй клик или быстрый выбор применяет период; закрытие без второго клика — прежний период.
function onSelect(value: Dayjs | [Dayjs, Dayjs] | Dayjs[]) {
    const [start, end] = value as [Dayjs | null, Dayjs | null]
    draft.value = value as [Dayjs, Dayjs]
    if (!start || !end) return
    isOpen.value = false
    period.value = [start.format('YYYY-MM-DD'), end.format('YYYY-MM-DD')]
}

function close() {
    if (!isOpen.value) return
    isOpen.value = false
    draft.value = [dayjs(period.value[0]), dayjs(period.value[1])]
}

function shiftMonth(step: number) {
    const start = dayjs(period.value[0]).add(step, 'month').startOf('month')
    period.value = [start.format('YYYY-MM-DD'), start.endOf('month').format('YYYY-MM-DD')]
}
</script>
